import type { CmsSsbtGameConfiguration } from '#src/interfaces/CmsConfig'

type SsbtGameConfigurationView = {
  childId: string | undefined
}

const createSsbtGameConfiguration = (
  config: CmsSsbtGameConfiguration | null | undefined
): SsbtGameConfigurationView => {
  const childId = config?.childId ? config.childId : undefined

  return {
    childId
  }
}

export type { SsbtGameConfigurationView }
export { createSsbtGameConfiguration }
